import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as headerActionCreators from '../../../actions/header';
let allActionCreators = Object.assign({}, headerActionCreators);

import {HeaderMenuContainer} from './HeaderMenu';


class Header extends React.Component {
  
  static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  dashboardNav() {
    this.context.router.push('/');
  }

  render() {
    return <div className='Header'>
      {this.props.header.pageBack ? 
        <div className='headerBack' onClick={::this.dashboardNav}>&lt; Back to Videos</div> :
        null
      }
      <div className='headerIcon' onClick={::this.dashboardNav}>
        <div className='iconWrapper'>
          <img src='/img/DDicon_white.svg' />
        </div>
      </div>
      <div className='headerRightMenu'><HeaderMenuContainer /></div>
    </div>
  }
}
export default Header;

function mapStateToProps(state) {
  return {
    header: state.header
  };
}

export const HeaderContainer = connect(
  mapStateToProps,
  allActionCreators
)(Header);


// WEBPACK FOOTER //
// ./src/components/views/header/Header.jsx